import { useParams } from 'react-router-dom';

import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

import { GET_SUPPLIERS } from '../queries/getSuppliers';

type RawData = {
  company: {
    suppliers: {
      edges: {
        node: {
          id: string;
          name: string;
          isArchived: boolean;
        };
      }[];
    };
  };
};

type Data = {
  id: string;
  name: string;
  isArchived: boolean;
}[];

export const useGetSupplierLowerCaseNamesQuery = (): QueryState<Data> => {
  const { company: companyId } = useParams();

  return useQuery<Data, RawData>({
    key: ['useGetSupplierLowerCaseNamesQuery', companyId],
    request: {
      type: 'graphQL',
      target: 'v2',
      query: GET_SUPPLIERS,
    },
    reshapeData: (rawData) => {
      const { edges } = rawData.company.suppliers;
      return edges.map(({ node }) => ({
        ...node,
        name: node.name.toLowerCase(),
      }));
    },
  });
};
